import * as reducers from './reducers'

export const constants = {
  NAME: 'dashboard'
}

export default { constants, reducers }